export const directLeftGroups = [
  [{ title: "전문위원실" }],
  [{ title: "현대관세무역연구원" }],
  [{ title: "식품검역검사연구소" }, { title: "품목분류원산지연구소" }],
];

export const managementOffice = {
  title: "경영기획실",
  teams: ["경영기획팀", "재경팀", "DX팀"],
};

export const mainOrganizations = [
  {
    title: "수도권총괄본부",
    children: [
      { title: "컨설팅본부", teams: ["컨설팅1팀", "컨설팅2팀"] },
      {
        title: "통관사업부문",
        teams: ["통관1팀", "통관2팀", "통관3팀", "업무지원팀"],
      },
      { title: "혁신전략부문", teams: ["전략CS팀", "인증및환급파트"] },
    ],
  },
  {
    title: "부산지점",
    children: [
      {
        title: "통관사업부문",
        teams: ["통관1팀", "통관2팀"],
        extraTeams: ["CS팀", "업무지원팀"],
      },
      {
        title: "검역센터",
        teams: ["검역팀", "전략검역팀", "검역통관팀", "검역컨설팅"],
      },
    ],
  },
  {
    title: "인천지점",
    children: [
      {
        title: "통관사업부문",
        teams: [
          "일반통관1팀",
          "일반통관2팀",
          "검역통관팀",
          "검역팀",
          "CS팀",
        ],
      },
      {
        title: "특송센터",
        teams: ["특송통관1팀", "특송통관2팀"],
        extraTeams: ["업무지원팀"],
      },
    ],
  },
  {
    title: "평택지점",
    children: [],
    // children: [{ title: "", teams: [], singleBox: true }],
  },
  {
    title: "울산지점",
    children: [],
    // children: [{ title: "", teams: [], singleBox: true }],
  },  
];
